import { useState, useEffect } from "react";
import {
  Grid,
  Button,
  TextField,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  CardHeader,
  CardContent,
  Loading,
} from "../../../../components";
import {
  GrupoProdutosService,
  SubgrupoProdutosService,
  FamiliaProdutosService,
  SubfamiliaProdutosService,
  // PessoaService,
  SaldoInicialService,
  notification,
} from "../../../../services";
import { responseErros } from "../../../../utils";
import { InputErros, value } from "../../../../helpers";
import saldoEmMassaValidator from "../middlewares/saldo-em-massa.validator";

const gruposProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new SubgrupoProdutosService();
const familiaProdutosService = new FamiliaProdutosService();
const subfamiliaProdutosService = new SubfamiliaProdutosService();
// const pessoaService = new PessoaService();
const saldoInicialService = new SaldoInicialService();

const SaldoEmMassaDialog = ({ openDialog, setOpenDialog, onSuccess }) => {
  const [filtros, setFiltros] = useState({});
  const [estoque, setEstoque] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const [gruposOptions, setGruposOptions] = useState([]);
  const [subgruposOptions, setSubgruposOptions] = useState([]);
  const [familiasOptions, setFamiliasOptions] = useState([]);
  const [subfamiliasOptions, setSubfamiliasOptions] = useState([]);
  // const [fornecedoresOptions, setFornecedoresOptions] = useState([]);

  useEffect(() => {
    if (openDialog) {
      buscarGruposProdutos();
      buscarSubgruposProdutos();
      buscarFamiliasProdutos();
      buscarSubfamiliasProdutos();
      // buscarFornecedores();
    }
  }, [openDialog]);

  // const buscarFornecedores = () => {
  //   pessoaService
  //     .getAll({ nonPaginated: true, tiposPessoaId: 2 })
  //     .then((result) => {
  //       if (!result.isAxiosError) setFornecedoresOptions(result.data);
  //       else responseErros(result);
  //     });
  // };

  const buscarGruposProdutos = () => {
    gruposProdutosService
      .getAll({ nonPaginated: true, ativado: true })
      .then((res) => {
        if (!res.isAxiosError) setGruposOptions(res.data);
        else responseErros(res);
      });
  };

  const buscarSubgruposProdutos = () => {
    subgrupoProdutosService
      .getAll({ nonPaginated: true, ativado: true })
      .then((res) => {
        if (!res.isAxiosError) setSubgruposOptions(res.data);
        else responseErros(res);
      });
  };

  const buscarFamiliasProdutos = () => {
    familiaProdutosService
      .getAll({ nonPaginated: true, ativado: true })
      .then((res) => {
        if (!res.isAxiosError) setFamiliasOptions(res.data);
        else responseErros(res);
      });
  };

  const buscarSubfamiliasProdutos = () => {
    subfamiliaProdutosService
      .getAll({ nonPaginated: true, ativado: true })
      .then((res) => {
        if (!res.isAxiosError) setSubfamiliasOptions(res.data);
        else responseErros(res);
      });
  };

  const handleChangeAutocomplete = (name, val) => {
    inputErros.limpar();
    setFiltros((prev) => ({ ...prev, [name]: val ? val.id : null }));
  };

  const handleInputChange = (e) => {
    inputErros.limpar();
    setFiltros((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const buildFiltrosBody = () => {
    const filtrosTemp = { ...filtros };

    for (const key in filtrosTemp) {
      if (filtrosTemp[key] == null) delete filtrosTemp[key];
    }

    return {
      ...filtrosTemp,
      restritiva: true,
      produtoGrade: true,
    };
  };

  const handleAplicar = async () => {
    const filtrosBody = buildFiltrosBody();
    const payload = { filtros: filtrosBody, estoque: parseFloat(estoque) };

    saldoEmMassaValidator
      .validate(payload, { abortEarly: false })
      .then(async () => {
        const confirmacao = await notification.confirmacao(
          "Saldo em Massa",
          "Todos os produtos encontrados pelo filtro terão o estoque ajustado. Deseja continuar?",
        );
        if (!confirmacao.isConfirmed) return;

        setLoading(true);
        const result = await saldoInicialService.cadastrarEmMassa(payload);
        setLoading(false);

        if (!result.isAxiosError) {
          notification.sucessoGenericos(
            "Saldo inicial em massa aplicado com sucesso!",
          );
          handleClose();
          if (onSuccess) onSuccess();
        } else {
          responseErros(result);
        }
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const handleClose = () => {
    setFiltros({});
    setEstoque("");
    inputErros.limpar();
    setOpenDialog(false);
  };

  return (
    <>
      <Dialog maxWidth="lg" fullWidth open={openDialog} onClose={handleClose}>
        <DialogContent>
          <CardHeader title="Saldo Inicial em Massa" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="grupoProdutoId"
                  options={gruposOptions}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText="Nenhum grupo encontrado"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Grupo de Produto"
                      variant="outlined"
                    />
                  )}
                  onChange={(_, val) =>
                    handleChangeAutocomplete("grupoProdutoId", val)
                  }
                  value={value.autoComplete(
                    gruposOptions,
                    filtros?.grupoProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="subgrupoProdutoId"
                  options={subgruposOptions}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText="Nenhum subgrupo encontrado"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subgrupo de Produto"
                      variant="outlined"
                    />
                  )}
                  onChange={(_, val) =>
                    handleChangeAutocomplete("subgrupoProdutoId", val)
                  }
                  value={value.autoComplete(
                    subgruposOptions,
                    filtros?.subgrupoProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="familiaProdutoId"
                  options={familiasOptions}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText="Nenhuma família encontrada"
                  renderInput={(params) => (
                    <TextField {...params} label="Família" variant="outlined" />
                  )}
                  onChange={(_, val) =>
                    handleChangeAutocomplete("familiaProdutoId", val)
                  }
                  value={value.autoComplete(
                    familiasOptions,
                    filtros?.familiaProdutoId,
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="subfamiliaProdutoId"
                  options={subfamiliasOptions}
                  autoHighlight
                  getOptionLabel={(option) =>
                    option.codigo
                      ? `${option.codigo} - ${option.descricao}`
                      : ""
                  }
                  noOptionsText="Nenhuma subfamília encontrada"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subfamília"
                      variant="outlined"
                    />
                  )}
                  onChange={(_, val) =>
                    handleChangeAutocomplete("subfamiliaProdutoId", val)
                  }
                  value={value.autoComplete(
                    subfamiliasOptions,
                    filtros?.subfamiliaProdutoId,
                  )}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="fornecedorId"
                  options={fornecedoresOptions}
                  autoHighlight
                  noOptionsText="Sem opções"
                  getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fornecedor"
                      variant="outlined"
                    />
                  )}
                  onChange={(_, val) =>
                    handleChangeAutocomplete("fornecedorId", val)
                  }
                  value={value.autoComplete(
                    fornecedoresOptions,
                    filtros?.fornecedorId,
                  )}
                />
              </Grid> */}
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Cód. Inicial"
                  name="codigoInicial"
                  value={filtros.codigoInicial || ""}
                  onChange={handleInputChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Cód. Final"
                  name="codigoFinal"
                  value={filtros.codigoFinal || ""}
                  onChange={handleInputChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Estoque a Aplicar"
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={estoque}
                  onChange={(e) => {
                    inputErros.limpar();
                    setEstoque(e.target.value);
                  }}
                  error={inputErros.get("estoque")}
                  fullWidth
                />
              </Grid>
            </Grid>
          </CardContent>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button variant="contained" color="padrao" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleAplicar}
            startIcon={
              <i
                className="ph-bold ph-check-circle"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            }
          >
            Aplicar Saldo em Massa
          </Button>
        </DialogActions>
      </Dialog>
      <Loading loading={loading} />
    </>
  );
};

export default SaldoEmMassaDialog;
